import React, { memo, useMemo } from 'react';
import { getResourceTo } from 'react/utils/utils';

import CollapseIcon from 'static/images/sidebar/collapse.svg';
import { useSidebar } from 'react/hooks/sidebar.hook';

function ToggleContainer() {
  const { toggleSidebar, isCollapsed } = useSidebar();

  const tooltipText = useMemo(
    () => isCollapsed ? 
      getResourceTo('sidebarMenu.toggleButton.expandTooltip') : 
      getResourceTo('sidebarMenu.toggleButton.collapseTooltip'), 
    [isCollapsed]
  );

  return (
    <div className="toggle-container">
      <button
        type="button"
        onClick={toggleSidebar}
        data-testid="toggle-container"
        title={tooltipText}
      >
        <img src={CollapseIcon} alt="Toggle Image" />
      </button>
    </div>
  );
}

export default memo(ToggleContainer);
